import { defineMessages } from 'react-intl';

// Todo: Copy needs to change - Remember to update language_LOCALE.json files !!!!
export default defineMessages({
  getStartedButtonText: {
    id: 'app.fullUpload.started.button.text',
    defaultMessage: 'Get Started',
  },
  tip1Title: {
    id: 'app.fullUpload.started.tip1.title',
    defaultMessage: 'Tip 1: Check our artwork guidelines',
  },
  tip1Text: {
    id: 'app.fullUpload.started.tip1.text',
    defaultMessage: 'Get help with bleed, trim and safe areas – and download Adobe CS and JPG templates.',
  },
  tip2Title: {
    id: 'app.fullUpload.started.tip2.title',
    defaultMessage: 'Tip 2: Remove any crop marks',
  },
  tip2Text: {
    id: 'app.fullUpload.started.tip2.text',
    defaultMessage: "Otherwise they'll print – so make sure your final design doesn't include them.",
  },
  tip3Title: {
    id: 'app.fullUpload.started.tip3.title',
    defaultMessage: 'Tip 3: Export your artwork as individual files',
  },
  tip3Text: {
    id: 'app.fullUpload.started.tip3.text',
    defaultMessage: 'They can be GIF, JPG, PDF or PNG. Just make sure to export them as single files.',
  },
});
